module.exports = __webpack_public_path__ + "img/story-18-1.jpeg";